export const defaultAppContext = {
  app_name: 'default',
};

export const defaultClientName = 'default';
